// Route: '/register'
import React, { useContext, useState } from 'react';
import styles from './RegisterPage.module.css';
import { ContrastButton } from '../../components/Buttons/Buttons';
import Nav from '../../components/Nav/Nav';
import PasswordInput from '../../components/PasswordInput/PasswordInput';
import TextInput from '../../components/TextInput/TextInput';
import { StoreContext } from '../../utils/store';
import { useHistory } from 'react-router-dom';

const RegisterPage = () => {
  const context = useContext(StoreContext);
  const [api] = context.api;
  const history = useHistory();

  // input states
  const [nameInput, setNameInput] = useState('');
  const [emailInput, setEmailInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');
  const [message, setMessage] = useState('');
  const [messageError, setMessageError] = useState(false);

  // api call functions
  const register = async () => {
    const response = await api.makeAPIRequest('admin/auth/register', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: emailInput,
        password: passwordInput,
        name: nameInput,
      })
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        localStorage.setItem('token', json.token);
        setMessageError(false);
        setMessage('');
        history.push('/');
      } else {
        setMessageError(true);
        setMessage(json.error);
      }
    } catch (e) {
      console.log('ERROR', e);
      setMessageError(true);
      setMessage('Sorry! Can\' connect to the server.');
    }
  };

  return (
    <section>
      <Nav visibilities={['true', 'true', 'false', 'false', 'false']} />
      <div className={styles.main}>
        <h2>Register</h2>
        <TextInput
          label='Name'
          name='name'
          onChange={e => setNameInput(e.target.value)}
          value={nameInput}
        />
        <TextInput
          label='Email'
          name='email'
          onChange={e => setEmailInput(e.target.value)}
          value={emailInput}
        />
        <PasswordInput
          name='password'
          onChange={e => setPasswordInput(e.target.value)}
          value={passwordInput}
        />
        <ContrastButton
          label='register-button'
          animated className={styles.button}
          onClick={register}
        >
          <span>Sign up</span>
        </ContrastButton>
        <p className={styles[messageError ? 'error' : 'message']}>{message}</p>
      </div>
    </section>
  );
};

export default RegisterPage;
